import { csrfTokenService } from '../csrf/CsrfTokenService'

export class ResetPasswordRepositoryFetch {
  async reset(email: string, next?: string): Promise<void> {
    const response: any = await this.getResponse(email, next)
    if (response.state === 'ok') {
      return Promise.resolve()
    }
    const errorMsg = Array.isArray(response.errors)
      ? response.errors.join(', ')
      : String(response.errors || 'Password reset failed')
    return Promise.reject(new Error(`Password reset failed: ${errorMsg}`))
  }

  private async getResponse(email: string, next?: string) {
    const { csrfToken } = await csrfTokenService()
    const url = next
      ? `/_/fallback/_/users/reset-password/?next=${encodeURIComponent(next)}`
      : '/_/fallback/_/users/reset-password/'

    return await $fetch(url, {
      method: 'POST',
      body: this.getFormData(email),
      headers: {
        'X-CSRFToken': csrfToken,
      },
    })
  }

  private getFormData(email: string): FormData {
    const formData = new FormData()
    formData.append('email', email)
    return formData
  }
}
